import * as api from '../../../../lib/api.js';
import { DownloadButton } from '../../../../components/DownloadButton';
import { useContext } from '../../context';
import { useShapefileContext } from './shapefile-context';
import { useGrowers } from '../../../../hooks/use-growers';
import { usePermission } from '../../../../hooks/use-permission';

export function ShapefileButton() {
  const canDownload = usePermission('DOWNLOAD_RX');
  const { arePrescriptionsSelected, getSelectedPrescriptionIds } = useContext();
  const { filters, setFilters, isFiltering, setFiltering } =
    useShapefileContext();
  const { selectedId: growerId } = useGrowers();

  const onDownload =
    !isFiltering && filters?.length
      ? () =>
          api.downloadLpkShapefiles(
            growerId,
            getSelectedPrescriptionIds(filters),
            filters.join(''),
          )
      : null;

  function onClick() {
    setFilters([]);
    setFiltering(true);
  }

  function onDownloaded() {
    setFilters([]);
  }
  return canDownload ? (
    <DownloadButton
      disabled={!arePrescriptionsSelected}
      preDownload={onClick}
      autoDownload={onDownload}
      postDownload={onDownloaded}
    >
      Download
    </DownloadButton>
  ) : null;
}
